import settingsModule from './settings.module';

export default settingsModule.config($stateProvider => {
    $stateProvider
        .state({
            parent: 'app',
            name: 'settings',
            url: '/settings',
            component: 'settings',
            resolve: {
                settingsItems: navigationService => navigationService.getSettingsNavigationItems()
            },
            redirectTo: transition => {
                if (transition.from().parent == 'settings') {
                    return transition.from().name;
                } else {
                    return transition
                        .injector()
                        .get('navigationService')
                        .getSettingsDefaultRedirectionState();
                }
            }
        })
        .state({
            parent: 'settings',
            name: 'settings_permission',
            url: '/permission',
            component: 'permission',
            protected: true
        })
        .state({
            parent: 'settings',
            name: 'settings_accountAuthentication',
            url: '/accountauthentication',
            component: 'accountAuthentication',
            protected: true
        })
        .state({
            name: 'settings_otherwise',
            url: '/*path',
            redirectTo: 'settings'
        })
        .state({
            parent: 'settings',
            name: 'settings_userProvisioning',
            url: '/userprovisioning',
            component: 'userProvisioning',
            protected: true
        });
});



// WEBPACK FOOTER //
// ./modules/settings/settings.states.js